import PortalLayout from "layouts/PortalLayout";

export default function AdminLayout() {
  return (
    <PortalLayout
      authGuard="admin"
      sidebarLayout="/admin"
      fallbackTitleAr="لوحة الإدارة"
      fallbackTitleEn="Admin Dashboard"
    />
  );
}
